/* global VERSION */
var systemConfigs = {
  client: 'SongbirdJS',
  version: VERSION,
  logging: {
    levels: {
      verbose: 0,
      debug: 3000,
      off: 5000
    },
    console: {
      level: 0
    },
    level: 'off',
    ajax: {
      enabled: true,
      level: 5000,
      bufferSize: 25,
      sendWithBufferLevel: 5000,
      batchSize: 10
    }
  },
  elementPrefix: 'Cardinal-',
  payments: {
    applePay: {
      name: 'Apple Pay',
      paymentBrandOptions: {
        start: {
          autoWired: false
        },
        autoShowPaymentButton: true,
        button: {
          id: 'ApplePay',
          elementType: 'div',
          whiteList: {
            color: [
              'white',
              'white-bordered',
              'black'
            ]
          }
        }
      }
    },
    cca: {
      name: 'ConsumerAuthentication',
      frameId: 'CCAFrame',
      termPath:{
        v2: 'TermURL/2.0/CCA'
      }
    },
    discoverWallet: {
      name: 'Discover Wallet',
      type: 'wallet',
      cookieDetectionPath: '/iframe/cookiedetection',
      paymentBrandOptions: {
        start:{
          required: true
        },
        autoShowPaymentButton: true,
        button: {
          id: 'DiscoverWallet',
          imagePath: 'https://d1nnphaioysusi.cloudfront.net/images/discover.button.png'
        },
      }
    },
    hostedFields: {
      name: 'HostedFields',
      minimumFields: [
        'AccountNumber'
      ]
    },
    paypal: {
      name: 'PayPal',
      braintree: {
        scripts: {
          client: 'https://js.braintreegateway.com/web/3.6.0/js/client.min.js',
          paypal: 'https://js.braintreegateway.com/web/3.6.0/js/paypal.min.js',
          dataCollection: 'https://js.braintreegateway.com/web/3.6.0/js/data-collector.min.js'
        }
      },
      paymentBrandOptions: {
        autoShowPaymentButton: true,
        button: {
          id: 'PayPal',
          imagePath: 'https://www.paypalobjects.com/webstatic/en_US/i/btn/png/',
          whiteList: {
            color: [
              'gold',
              'silver',
              'blue'
            ],
            shape: [
              'pill',
              'rect'
            ],
            size: [
              '26px',
              '34px',
              '44px',
              '60px'
            ],
            style: [
              'paypal',
              'paypalcheckout'
            ]
          }
        }
      }
    },
    visaCheckout: {
      name: 'Visa Checkout',
      paymentBrandOptions: {
        start: {
          require: false,
        },
        button: {
          id: 'Visa-Checkout',
          whiteList: {
            color: [
              'standard',
              'neutral'
            ],
            locale: null,
            size: [
              '154',
              '213',
              '425'
            ],
            height: [
              '34',
              '47',
              '94'
            ],
            width: null
          }
        }
      }
    }
  },
  defaultJWTAlgorithm: 'HS256',
  whiteList: {
    buttonConfigurations: [
      'containerId'
    ]
  },
  paymentLoadTimeout: 4000,
  initTimeout: 2000,
  defaultBinProfilingDelay: 2000,
  enableEndpointMonitor: true,
  farnsworthLabs: {
    CorsRetry: {
      maxAttempts: 2,
      timeout: 4000
    }
  }
};

systemConfigs['button'] = {
  containerId: systemConfigs.elementPrefix + 'Payments'
};

module.exports = systemConfigs;


//////////////////
// WEBPACK FOOTER
// ./config/systemDefaultConfig.js
// module id = 28
// module chunks = 0 5 20